module.exports = __webpack_public_path__ + "assets/img/familyCrest-8a288ba7.png";